<template>
  <div id="app">
    <navbar class="z-10" />
    <router-view />
    <!-- <div class="elfsight-app-66c6656c-9e0c-4f5d-9c9d-b147f0f060fa"></div> -->
    <Footer />
  </div>
</template>

<script>
import 'lazysizes'

import Footer from './components/Footer.vue'
import Navbar from './components/Navbar.vue'

// document.addEventListener('lazybeforeunveil', function(e) {
//   const bg = e.target.getAttribute('data-bg')
//   if (bg) {
//     e.target.style.backgroundImage = `url(${bg})`
//   }
// })

export default {
  name: 'App',
  components: {
    Footer,
    Navbar,
  },
}
</script>

<style>
@import './assets/css/tailwind.css';
body {
  @apply text-gray-600;
}
</style>
